import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import {
  DEFAULT_SECTION,
  MAP_SECTIONS,
  SECTION_SEGMENT_INDEX,
} from '@/routes/routes';
import { VIEW_MODE } from '@/types';

import { useMapViewMode } from './useMapViewMode';

export function useIsMapView(): boolean {
  const location = useLocation();
  const { view } = useMapViewMode();

  return useMemo(() => {
    const pathParts = location.pathname.split('/');
    const activeSection = pathParts[SECTION_SEGMENT_INDEX] || DEFAULT_SECTION;
    const isMapSection = (MAP_SECTIONS as readonly string[]).includes(
      activeSection
    );
    return isMapSection && view === VIEW_MODE.MAP;
  }, [location.pathname, view]);
}
